import { onBeforeUnmount, onMounted, ref, type Ref } from 'vue'

export function optionLetter(index: number): string {
  return String.fromCharCode(65 + index)
}

const phaseLabels: Record<string, string> = {
  LOBBY: 'lobby', BLUFF_OPEN: 'bluffing', REVIEW: 'host review', VOTE_OPEN: 'voting', REVEAL: 'reveal',
  STANDINGS: 'standings', COMPLETE: 'final', ENDED: 'ended',
}

/** Friendly phase names for both game modes. */
export function phaseName(phase: string | undefined): string {
  if (!phase) return ''
  return phaseLabels[phase] ?? phase.replaceAll('_', ' ').toLowerCase()
}

/** A clock that ticks four times a second while the component is mounted, for server-authoritative countdowns. */
export function useClock(): Ref<number> {
  const now = ref(Date.now())
  let timer: number | undefined
  onMounted(() => { timer = window.setInterval(() => { now.value = Date.now() }, 250) })
  onBeforeUnmount(() => { if (timer) window.clearInterval(timer) })
  return now
}

export function secondsLeft(closeAt: string | null | undefined, now: number): number | null {
  return closeAt ? Math.max(0, Math.ceil((Date.parse(closeAt) - now) / 1000)) : null
}
